<template>
    <div id="institution_c">
        <div style="height: 120px;border-bottom: 2px dashed #eee">
            <el-row>
                <el-col>
                    <span class="demonstration" style="border-radius: 5px;margin-right: 15px">时间范围</span>
                    <el-date-picker
                            @click.native="typeChange"
                            style="width: 160px;margin-right: 50px"
                            v-model="dateValue"
                            type="month"
                            placeholder="选择月">
                    </el-date-picker>
                    <span class="demonstration" style="margin-right: 15px">
                年份
            </span>
                    <el-select style="width: 160px" v-model="dateValue2"  placeholder="请选择" value="">
                        <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>

                    <div style="float: right">
                        <span style="margin-right: 15px">人员</span>
                        <inputSelect :handleSelectInput="handleSelectInputClick"></inputSelect>
                    </div>
                </el-col>
                <el-col span="24" style="margin-top: 24px">
                    <el-button type="primary" size="small" @click="searchWeekList"
                               style="background: #4EC880;border: none">
                        查询
                    </el-button>
                    <el-button type="danger" size="small" @click="ResetClick"
                               style="background: #D0021B;border: none">
                        重置
                    </el-button>
                </el-col>
            </el-row>
        </div>
        <el-row v-show="onoff" style="margin-top: 20px">

            <el-col span="24"><span style="font-size: 18px;">2019年9月</span></el-col>
            <el-col span="7">
                <div  >
                    <p>
                        <span style="font-size: 12px;display: inline-block;width: 120px;color: #909399">指标金额</span>
                        <span>1,350,000</span>
                    </p>
                    <p>
                        <span style="font-size: 12px;display: inline-block;width: 120px;color: #909399">销售金额</span>
                        <span style="color:#FF9901 ">1,599,500</span>
                    </p>
                    <p>
                        <span style="font-size: 12px;display: inline-block;width: 120px;color: #909399">指标达成率</span>
                        <span style="color:#FF9901 ">118.48%</span>
                    </p>
                </div>
            </el-col>
            <el-col span="1" style="border: 1px transparent solid;">
                <div style="height: 100px;border: 1px solid #bbbbbb;width: 0px;margin: 50px auto">

                </div>
            </el-col>
            <el-col span="7" style="border: 1px solid transparent">
                <div style="width: 100%;height: 100%">
                    <ul style="width: 100%;max-width: 300px;margin: auto">
                        <li style="margin-top: 16px;overflow: hidden;width: 100%">
                            <div style="width: 50px;height: 20px;float: left;line-height: 20px">
                                产品1
                            </div>
                            <div style="float: left;width: calc(100% - 50px)">
                                <el-rate
                                        low-threshold="6"
                                        high-threshold="9"
                                        style="float: right;margin-bottom: 5px"
                                        disabled
                                        v-model="value1"
                                        :max="max"
                                        disabled-void-color="#9B9B9B"
                                        disabled-void-icon-class="iconfont_Add icon-shixinzhengfangxing"
                                        :iconClasses="iconClasses"
                                        void-color="#9B9B9B"
                                        void-icon-class="iconfont_Add icon-shixinzhengfangxing"
                                        :colors="colors"
                                        >
                                </el-rate>
                                <span style="float: right;color: #4A90E2;font-size: 12px;">实际销量 46,800   指标金额 40,000</span>
                            </div>
                        </li>
                        <li style="margin-top: 16px;overflow: hidden;width: 100%">
                            <div style="width: 50px;height: 20px;float: left;line-height: 20px">
                                产品2
                            </div>
                            <div style="float: left;width: calc(100% - 50px)">
                                <el-rate
                                        low-threshold="6"
                                        high-threshold="9"
                                        style="float: right;margin-bottom: 5px"
                                        disabled
                                        v-model="value2"
                                        :max="max"
                                        disabled-void-color="#9B9B9B"
                                        disabled-void-icon-class="iconfont_Add icon-shixinzhengfangxing"
                                        :iconClasses="iconClasses"
                                        void-color="#9B9B9B"
                                        void-icon-class="iconfont_Add icon-shixinzhengfangxing"
                                        :colors="colors"
                                >
                                </el-rate>
                                <span style="float: right;color: #4A90E2;font-size: 12px;">实际销量 24,900   指标金额 30,000</span>
                            </div>
                        </li>
                        <li style="margin-top: 16px;overflow: hidden;width: 100%">
                            <div style="width: 50px;height: 20px;float: left;line-height: 20px">
                                产品3
                            </div>
                            <div style="float: left;width: calc(100% - 50px)">
                                <el-rate
                                        low-threshold="6"
                                        high-threshold="9"
                                        style="float: right;margin-bottom: 5px"
                                        disabled
                                        v-model="value3"
                                        :max="max"
                                        disabled-void-color="#9B9B9B"
                                        disabled-void-icon-class="iconfont_Add icon-shixinzhengfangxing"
                                        :iconClasses="iconClasses"
                                        void-color="#9B9B9B"
                                        void-icon-class="iconfont_Add icon-shixinzhengfangxing"
                                        :colors="colors"
                                >
                                </el-rate>
                                <span style="float: right;color: #4A90E2;font-size: 12px;">实际销量 25,750   指标金额 25,000</span>
                            </div>
                        </li>
                        <li style="margin-top: 16px;overflow: hidden;width: 100%">
                            <div style="width: 50px;height: 20px;float: left;line-height: 20px">
                                产品4
                            </div>
                            <div style="float: left;width: calc(100% - 50px)">
                                <el-rate
                                        low-threshold="6"
                                        high-threshold="9"
                                        style="float: right;margin-bottom: 5px"
                                        disabled
                                        v-model="value4"
                                        :max="max"
                                        disabled-void-color="#9B9B9B"
                                        disabled-void-icon-class="iconfont_Add icon-shixinzhengfangxing"
                                        :iconClasses="iconClasses"
                                        void-color="#9B9B9B"
                                        void-icon-class="iconfont_Add icon-shixinzhengfangxing"
                                        :colors="colors"
                                >
                                </el-rate>
                                <span style="float: right;color: #4A90E2;font-size: 12px;">实际销量 25,750   指标金额 25,000</span>
                            </div>
                        </li>

                    </ul>
                </div>
            </el-col>
<!--            <el-col span="1" style="border: 1px transparent solid;">-->
<!--                <div style="height: 100px;border: 1px solid #bbbbbb;width: 0px;margin: 50px auto">-->

<!--                </div>-->
<!--            </el-col>-->
<!--            <el-col style="margin-bottom: 20px;border: 1px solid transparent;" span="7">-->
<!--                <div style="width: 100%;height: 100%">-->
<!--                    <ul style="width: 100%;max-width: 300px;margin: auto">-->
<!--                        <li style="margin-top: 16px;overflow: hidden;width: 100%">-->
<!--                            <div style="width: 50px;height: 20px;float: left;line-height: 20px">-->
<!--                                A类-->
<!--                            </div>-->
<!--                            <div style="float: left;width: calc(100% - 50px)">-->
<!--                                <el-progress  :stroke-width="20"  :percentage="98"-->
<!--                                              style="margin-bottom: 5px;width: 100%">-->
<!--                                </el-progress>-->
<!--                                <span style="float: right;color: #4A90E2;font-size: 12px;">目标客户总数 53人，当月已拜访 53人</span>-->
<!--                            </div>-->
<!--                        </li>-->
<!--                        <li style="margin-top: 16px;overflow: hidden;width: 100%">-->
<!--                            <div style="width: 50px;height: 20px;float: left;line-height: 20px">-->
<!--                                A类-->
<!--                            </div>-->
<!--                            <div style="float: left;width: calc(100% - 50px)">-->
<!--                                <el-progress  :stroke-width="20"  :percentage="98"-->
<!--                                              style="margin-bottom: 5px;width: 100%">-->
<!--                                </el-progress>-->
<!--                                <span style="float: right;color: #4A90E2;font-size: 12px;">目标客户总数 53人，当月已拜访 53人</span>-->
<!--                            </div>-->
<!--                        </li>-->
<!--                        <li style="margin-top: 16px;overflow: hidden;width: 100%">-->
<!--                            <div style="width: 50px;height: 20px;float: left;line-height: 20px">-->
<!--                                A类-->
<!--                            </div>-->
<!--                            <div style="float: left;width: calc(100% - 50px)">-->
<!--                                <el-progress  :stroke-width="20"  :percentage="98"-->
<!--                                              style="margin-bottom: 5px;width: 100%">-->
<!--                                </el-progress>-->
<!--                                <span style="float: right;color: #4A90E2;font-size: 12px;">目标客户总数 53人，当月已拜访 53人</span>-->
<!--                            </div>-->
<!--                        </li>-->
<!--                        <li style="margin-top: 16px;overflow: hidden;width: 100%">-->
<!--                            <div style="width: 50px;height: 20px;float: left;line-height: 20px">-->
<!--                                A类-->
<!--                            </div>-->
<!--                            <div style="float: left;width: calc(100% - 50px)">-->
<!--                                <el-progress  :stroke-width="20"  :percentage="98"-->
<!--                                              style="margin-bottom: 5px;width: 100%">-->
<!--                                </el-progress>-->
<!--                                <span style="float: right;color: #4A90E2;font-size: 12px;">目标客户总数 53人，当月已拜访 53人</span>-->
<!--                            </div>-->
<!--                        </li>-->

<!--                    </ul>-->
<!--                </div>-->
<!--            </el-col>-->


            <el-col span="24" style="margin-top: 10px">
                <el-row >
                    <el-col span="7" style="text-align: center;color: #3998f7">数据汇总</el-col>
                    <el-col span="1" style="border: 1px transparent solid;">
                    </el-col>
                    <el-col span="7" style="text-align: center;color: #3998f7">拜访覆盖</el-col>
                    <el-col span="1" style="border: 1px transparent solid;">
                    </el-col>
                    <el-col span="7" style="text-align: center;color: #3998f7">拜访达标</el-col>
                </el-row>
            </el-col>

        </el-row>
        <el-row v-show="!onoff" style="margin-top: 20px">
            <el-col span="24"><span style="font-size: 18px;">2019年度</span></el-col>
            <el-col span="7">
                <div  >
                    <p>
                        <span style="font-size: 12px;display: inline-block;width: 120px;color: #909399">指标金额</span>
                        <span>1,350,000</span>
                    </p>
                    <p>
                        <span style="font-size: 12px;display: inline-block;width: 120px;color: #909399">销售金额</span>
                        <span style="color:#FF9901 ">1,599,500</span>
                    </p>
                    <p>
                        <span style="font-size: 12px;display: inline-block;width: 120px;color: #909399">指标达成率</span>
                        <span style="color:#FF9901 ">118.48%</span>
                    </p>
                </div>
            </el-col>
            <el-col span="1" style="border: 1px transparent solid;">
                <div style="height: 100px;border: 1px solid #bbbbbb;width: 0px;margin: 50px auto">

                </div>
            </el-col>
            <el-col :span="7" style="">
                <div id="institution_c_room" style="width:100%;height:230px;"></div>
            </el-col>
            <el-col span="1" style="border: 1px transparent solid;">
                <div style="height: 100px;border: 1px solid #bbbbbb;width: 0px;margin: 50px auto">

                </div>
            </el-col>
            <el-col :span="7" style="">
                <div id="institution_c_room_tow" style="width:100%;height: 230px;"></div>
            </el-col>
            <el-col span="24">
                <el-row >
                    <el-col span="7" style="text-align: center;color: #3998f7">数据汇总</el-col>
                    <el-col span="1" style="border: 1px transparent solid;"></el-col>
                    <el-col span="7" style="text-align: center;color: #3998f7">拜访覆盖</el-col>
                    <el-col span="1" style="border: 1px transparent solid;"></el-col>
                    <el-col span="7" style="text-align: center;color: #3998f7">拜访达标</el-col>
                </el-row>
            </el-col>

        </el-row>

        <el-row style="margin-top: 20px">
            <el-table
                      :data="tableData"
                      style="width: 100%">
                <el-table-column
                        prop="date"
                        label="医生姓名"
                        sortable
                >
                </el-table-column>
                <el-table-column
                        prop="name"
                        label="所在机构"
                        sortable
                >
                </el-table-column>
                <el-table-column
                        prop="address"
                        label="所在科室"
                        sortable>
                </el-table-column>
                <el-table-column
                        prop="address"
                        sortable
                        label="客户等级">
                </el-table-column>
                <el-table-column
                        prop="address"
                        sortable
                        label="拜访次数">
                </el-table-column>
                <el-table-column
                        prop="address"
                        sortable
                        label="是否达标">
                </el-table-column>
            </el-table>
        </el-row>
    </div>
</template>

<script>
    import inputSelect from '../../../../calendar/components/components/inputSelect'
    export default {
        name: "institution",
        data(){
            return {
                form:{},
                tableData: [{
                    date: '王晓云',
                    name: '4',
                    address: '-'
                }, {
                    date: '王晓云',
                    name: '3',
                    address: '-'
                }, {
                    date: '王晓云',
                    name: '2',
                    address: '-'
                }, {
                    date: '王晓云',
                    name: '2',
                    address: '-'
                }],
                onoff:false,
                roomChart:'',
                gradeChart:'',
                max:10,
                // value:6.7,
                // iconClasses: [divGreen, divGreen, divGreen],
                value1: 10,
                value2: 8.3,
                value3: 10,
                value4: 5.2,
                iconClasses: ['iconfont_Add icon-shixinzhengfangxing', 'iconfont_Add icon-shixinzhengfangxing',
                    'iconfont_Add icon-shixinzhengfangxing',
                    'iconfont_Add icon-shixinzhengfangxing', 'iconfont_Add icon-shixinzhengfangxing',
                    'iconfont_Add icon-shixinzhengfangxing',
                    'iconfont_Add icon-shixinzhengfangxing', 'iconfont_Add icon-shixinzhengfangxing',
                    'iconfont_Add icon-shixinzhengfangxing',
                    'iconfont_Add icon-shixinzhengfangxing'],
                colors:['#ED3B3F','#FF9901','#7ED321'],
                dateValue2:'',
                dateValue:'',
            }
        },
        components:{
            inputSelect
        },
       mounted(){
           this.init()

           window.onresize = () => {
               this.roomChart.resize()
               this.gradeChart.resize()
           }
       },
        methods:{
            init(){

                this.roomChart=this.$echarts.init(document.getElementById('institution_c_room'));
                this.gradeChart=this.$echarts.init(document.getElementById('institution_c_room_tow'));
                var option = {
                    //--------------    标题 title  ----------------
                    // title: {
                    //     text: '主标题',
                    //     textStyle:{					//---主标题内容样式
                    //         color:'#fff'
                    //     },
                    //
                    //     subtext:'副标题',			//---副标题内容样式
                    //     subtextStyle:{
                    //         color:'#bbb'
                    //     },
                    //
                    //     padding:[0,0,100,100]				//---标题位置,因为图形是是放在一个dom中,因此用padding属性来定位
                    //
                    // },

                    // //----------------   图例 legend  -----------------
                    // legend: {
                    //     type:'plain',				//----图例类型，默认为'plain'，当图例很多时可使用'scroll'
                    //     top:'1%',					//----图例相对容器位置,top\bottom\left\right
                    //     selected:{
                    //         '销量':true,			//----图例选择,图形加载出来会显示选择的图例，默认为true
                    //     },
                    //     textStyle:{					//----图例内容样式
                    //         color:'#fff',				//---所有图例的字体颜色
                    //         //backgroundColor:'black',	//---所有图例的字体背景色
                    //     },
                    //     tooltip:{					//图例提示框，默认不显示
                    //         show:true,
                    //         color:'red',
                    //     },
                    //     data:[						//----图例内容
                    //         {
                    //             name:'销量',
                    //             icon:'circle',			//----图例的外框样式
                    //             textStyle:{
                    //                 color:'#fff',		//----单独设置某一个图例的颜色
                    //                 //backgroundColor:'black',//---单独设置某一个图例的字体背景色
                    //             }
                    //         }
                    //     ],
                    // },

                    //--------------   提示框 -----------------
                    tooltip: {
                        show:true,					//---是否显示提示框,默认为true
                        trigger:'item',				//---数据项图形触发
                        axisPointer:{				//---指示样式
                            type:'shadow',
                            axis:'auto',

                        },
                        padding:5,
                        textStyle:{					//---提示框内容样式
                            color:"#fff",
                        },
                    },
                    //-------------  grid区域  ----------------
                    grid:{
                        show:false,					//---是否显示直角坐标系网格
                        top:80,						//---相对位置，top\bottom\left\right
                        containLabel:false,			//---grid 区域是否包含坐标轴的刻度标签
                        tooltip:{					//---鼠标焦点放在图形上，产生的提示框
                            show:true,
                            trigger:'item',			//---触发类型
                            textStyle:{
                                color:'white',
                            },
                        }
                    },

                    //-------------   x轴   -------------------
                    xAxis: {
                        show:true,					//---是否显示
                        position:'bottom',			//---x轴位置
                        offset:0,					//---x轴相对于默认位置的偏移
                        type:'category',			//---轴类型，默认'category'
                        name:'',				//---轴名称
                        nameLocation:'end',			//---轴名称相对位置
                        nameTextStyle:{				//---坐标轴名称样式
                            color:"#9D9D9D",
                            padding:[5,0,0,-5],	//---坐标轴名称相对位置
                        },
                        nameGap:15,					//---坐标轴名称与轴线之间的距离
                        //nameRotate:270,			//---坐标轴名字旋转

                        axisLine:{					//---坐标轴 轴线
                            show:false,					//---是否显示

                            //------------------- 箭头 -------------------------
                            symbol:['none', 'arrow'],	//---是否显示轴线箭头
                            symbolSize:[8, 8] ,			//---箭头大小
                            symbolOffset:[0,7],			//---箭头位置

                            //------------------- 线 -------------------------
                            lineStyle:{
                                color:'#9D9D9D',
                                width:1,
                                type:'solid',
                            },
                        },
                        axisTick:{					//---坐标轴 刻度
                            show:false,					//---是否显示
                            inside:true,				//---是否朝内
                            lengt:5,					//---长度
                            lineStyle:{
                                //color:'red',			//---默认取轴线的颜色
                                width:1,
                                type:'solid',
                            },
                        },
                        axisLabel:{					//---坐标轴 标签
                            show:true,					//---是否显示
                            inside:false,				//---是否朝内
                            rotate:0,					//---旋转角度
                            margin: 5,					//---刻度标签与轴线之间的距离
                            //color:'red',				//---默认取轴线的颜色
                        },
                        splitLine:{					//---grid 区域中的分隔线
                            show:false,					//---是否显示，'category'类目轴不显示，此时我的X轴为类目轴，splitLine属性是无意义的
                            lineStyle:{
                                color:'#9D9D9D',
                                width:1,
                                type:'solid',
                            },
                        },
                        splitArea:{					//--网格区域
                            show:false,					//---是否显示，默认false
                        },
                        data: ["1","2","3","4","5","6","7","8","9","10","11","12"],//内容
                    },

                    //----------------------  y轴  ------------------------
                    yAxis: {
                        show:true,					//---是否显示
                        position:'left',			//---y轴位置
                        offset:0,					//---y轴相对于默认位置的偏移
                        type:'value',			//---轴类型，默认'category'
                        name:'',				//---轴名称
                        nameLocation:'end',			//---轴名称相对位置value
                        nameTextStyle:{				//---坐标轴名称样式
                            color:"#D8D8D8",
                            padding:[5,0,0,5],	//---坐标轴名称相对位置
                        },
                        nameGap:15,					//---坐标轴名称与轴线之间的距离
                        //nameRotate:270,			//---坐标轴名字旋转

                        axisLine:{					//---坐标轴 轴线
                            show:false,					//---是否显示

                            //------------------- 箭头 -------------------------
                            symbol:['none', 'arrow'],	//---是否显示轴线箭头
                            symbolSize:[8, 8] ,			//---箭头大小
                            symbolOffset:[0,7],			//---箭头位置

                            //------------------- 线 -------------------------
                            lineStyle:{
                                color:'#D8D8D8',
                                width:1,
                                type:'solid',
                            },
                        },
                        axisTick:{					//---坐标轴 刻度
                            show:true,					//---是否显示
                            inside:true,				//---是否朝内
                            lengt:3,					//---长度
                            lineStyle:{
                                //color:'red',			//---默认取轴线的颜色
                                width:1,
                                type:'solid',
                            },
                        },
                        axisLabel:{					//---坐标轴 标签
                            show:false,					//---是否显示
                            inside:false,				//---是否朝内
                            rotate:0,					//---旋转角度
                            margin: 8,					//---刻度标签与轴线之间的距离
                            //color:'red',				//---默认取轴线的颜色
                        },
                        splitLine:{					//---grid 区域中的分隔线
                            show:true,					//---是否显示，'category'类目轴不显示，此时我的y轴为类目轴，splitLine属性是有意义的
                            lineStyle:{
                                color:'#D8D8D8',
                                width:1,
                                type:'dashed',			//---类型
                            },
                        },
                        splitArea:{					//--网格区域
                            show:false,					//---是否显示，默认false
                        },
                        minorTick:{
                            show:true,
                        }
                    },

                    //------------ 内容数据  -----------------
                    series: [
                        {
                            name: '销量',				//---系列名称
                            type: 'bar',				//---类型
                            legendHoverLink:true,		//---是否启用图例 hover 时的联动高亮
                            label:{						//---图形上的文本标签
                                show:false,
                                position:'insideTop',	//---相对位置
                                rotate:0,				//---旋转角度
                                color:'#fff',
                            },
                            itemStyle:{					//---图形形状
                                color:'#FF9901',
                                barBorderRadius:[18,18,0,0],
                            },
                            barWidth:'10',				//---柱形宽度
                            barCategoryGap:'30%',		//---柱形间距
                            data: [3020, 4800, 3600, 6050, 4320, 6200,5050,7200,4521,6700,8000,5020]
                        },
                        // {
                        //     name: '平均温度',
                        //     type: 'line',
                        //     yAxisIndex: 1,
                        //     data: [3020, 4800, 3600, 6050, 4320, 6200,5050,7200,4521,6700,8000,5020]
                        // }
                    ]
                };
                this.roomChart.setOption(option)
                this.gradeChart.setOption({
                    title : {
                        text: '',
                        x:'center',
                        y: 'bottom',
                        textStyle:{
                            color:"#6fa7e8"
                        }
                    },
                    series : [
                        {
                            name: '访问来源',
                            type: 'pie',    // 设置图表类型为饼图
                            radius: '50%',
                            label : {
                                normal : {
                                    formatter: '{w|{b} {d}%}\n{n|({c}人)}',
                                    rich: {
                                        w:{
                                            fontSize : 15,
                                            color:'#ff9901'
                                        },
                                        n:{
                                            color: '#fff',
                                            align: 'center',
                                            fontSize: 15,
                                        }

                                    }
                                }
                            },
                            data:[
                                {value:31, name:'D类'},
                                {value:29, name:'C类'},
                                {value:13, name:'B类'},
                                {value:14, name:'A类'},
                            ],
                            center:["50%","40%"]
                        }
                    ],
                    color:["#50e3c2","#63a9fa","#d16366","#fecfa3"]
                })

            },
            handleSelectInputClick(){

            },
            typeChange(){
               if (this.onoff){
                   this.onoff = false
                   this.$nextTick( ()=>{
                       // this.init()
                       //
                       // window.onresize = () => {
                       //     this.roomChart.resize()
                       //     this.gradeChart.resize()
                       // }
                   })
               } else {
                   // this.roomChart.clear()
                   // this.gradeChart.clear()
                   this.onoff = true
               }


            }

        }
    }
</script>

<style scoped>
   #institution_c .custDiv_border:before{
        content:" ";
        height: 100px;
        border: 1px solid #9FA5AC;
        float: right;
        margin-top: 40px;
    }
   #institution_c >>> .el-progress-bar{
       padding-right: 60px;
   }
   #institution_c >>> .el-progress-bar__outer{
      border-radius: 2px;
  }
   #institution_c >>> .el-progress-bar__inner{
        border-radius: 2px;
    }
   #institution_c >>> .el-rate__icon{
        border-radius: 5px;
       overflow: hidden;
    }
   #institution_c >>> .el-rate__item{
        width: 18px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/components/salesReached/components/institution.vue